"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSwitcher = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSwitcher = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, threshold = _a.threshold, space = _a.space;
    return "\n    > * {\n      display: flex;\n      flex-wrap: wrap;\n      margin: calc((".concat(theme.space[space], " / 2) * -1);\n    }\n\n    > * > * {\n      flex-grow: 1;\n      flex-basis:\n        calc((").concat(threshold, " - (100% - ").concat(theme.space[space], ")) * 999);\n      margin: calc(").concat(theme.space[space], " / 2);\n    }\n  ");
});
var templateObject_1;
